import { defineNuxtPlugin } from '#app'
import { plugin, defaultConfig } from '@formkit/vue'
import { resetCount } from '@formkit/core'
import config from '/usr/src/app/formkit.config.js'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:rendered', () => {
    resetCount()
  })
  nuxtApp.vueApp.use(plugin, defaultConfig(config))
})
